// eslint-disable-next-line import/no-cycle
import { updateProjectTasksBySP } from '@/services/repository';

import { UPDATE_TASKS } from '@/store/task/actionTypes';

export default {
  async [UPDATE_TASKS](store, options) {
    try {
      const result = await updateProjectTasksBySP(options.projectId, options.tasks);
      return result;
    } catch (e) {
      console.error('update tasks error:', e);
      throw e;
    }
  },
};
